import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-results',
  templateUrl: './empty-results.component.html',
  styleUrls: ['./empty-results.component.scss'],
  standalone: false
})
export class EmptyResultsComponent {
  @Input() header!: string;
}
